import { User } from '@xver/@types/user';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';
import { KYCInline } from '@xver/components/Molecules';
import { useTranslation } from 'react-i18next';

interface KYCSectionProps {
    user: User;
}

export default function KYCSection({ user }: KYCSectionProps) {
    const { t } = useTranslation('profile');
    return (
        <DialogBox label={t('kyc.title')} description={t('kyc.description')} classNames="p-0">
            <KYCInline user={user} />
        </DialogBox>
    );
}
